module.exports = __webpack_public_path__ + "static/media/Ian Turner.5646d226.png";